import { render, staticRenderFns } from "./ManufacturingVendorList.vue?vue&type=template&id=2afdba10&scoped=true&"
import script from "./ManufacturingVendorList.vue?vue&type=script&lang=js&"
export * from "./ManufacturingVendorList.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturingVendorList.vue?vue&type=style&index=0&id=2afdba10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afdba10",
  null
  
)

export default component.exports